// Angular imports
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// Component imports
import {
  MessageBoxComponent,
  CCMessageBoxIcon
} from '@therealmanage/ciranet-ui-common';

// Service imports
import { UserService } from '../../_services/data-services/user.service';
import { ServerErrorService } from '../../_services/shared-services/server-error.service';
import { HelperService } from '../../_services/shared-services/helper.service';

// Model imports
import { ValidateUserInfoParameterDto } from '../../_models/validate-user-info-dto';
import { ValidateUserInfoResultDto } from '../../_models/validate-userinfo-result-dto';
import { RxjsUtils } from '@therealmanage/ciranet-ui-common';

@Component({
  selector: 'app-validate-user',
  templateUrl: './validate-user.component.html',
  styleUrls: ['./validate-user.component.scss'],
  standalone: false
})
export class ValidateUserComponent implements OnInit {
  @ViewChild('messageBox', { static: false }) messageBox: MessageBoxComponent;

  loadingVisible = false;
  validateSuccess = false;
  missingInformation = false;
  isAlreadyApproved = false;
  isProduction = false;
  userInfo: ValidateUserInfoParameterDto;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private errorService: ServerErrorService,
    private helperService: HelperService
  ) {}

  ngOnInit() {
    this.userInfo = new ValidateUserInfoParameterDto();
    RxjsUtils.subscribeToQueryParamMap(this.route, (params) => {
      this.userInfo.email = params.get('e')?.trim() || '';
      this.userInfo.userName = params.get('u')?.trim() || '';
      this.userInfo.guid = params.get('g')?.trim() || '';

      if (!(this.userInfo.email && this.userInfo.userName)) {
        this.missingInformation = true;
        return;
      }

      this.loadingVisible = true;

      RxjsUtils.safeSubscribe(
        this.userService.validateUser(this.userInfo),
        (data: ValidateUserInfoResultDto) => {
          this.loadingVisible = false;
          this.missingInformation = data.isMissingValidationInformation;
          this.isAlreadyApproved = data.isAlreadyApproved;
          this.validateSuccess = data.isSuccess;

          if (data.isSuccess || data.isAlreadyApproved) {
            this.helperService.subjectLoginHeaderText.next(
              'Validation Successfully Completed'
            );
          }

          if (!data.isSuccess && !data.isAlreadyApproved) {
            this.messageBox.showWithFixedWidthAndIcon(
              CCMessageBoxIcon.error,
              'Error',
              `There is an issue validating user. ${data.errorMessage}`,
              320
            );
          }
        },
        (error) => {
          this.loadingVisible = false;
          this.errorService.displayError(error);
        }
      );
    });
  }
}
